var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCollapseHeight = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 16.512 8.502 19.77a.89.89 0 0 1-.628.23.89.89 0 0 1-.627-.23.76.76 0 0 1-.247-.585q0-.354.247-.584l3.475-3.238q.516-.48 1.278-.48c.762 0 .934.16 1.278.48l3.475 3.238a.77.77 0 0 1 .247.584.76.76 0 0 1-.247.585.89.89 0 0 1-.627.23.88.88 0 0 1-.628-.23zm0-9.024 3.498-3.258a.88.88 0 0 1 .628-.23q.381 0 .627.23a.76.76 0 0 1 .247.585.76.76 0 0 1-.247.584l-3.475 3.238q-.516.48-1.278.48c-.762 0-.934-.16-1.278-.48L7.247 5.4A.76.76 0 0 1 7 4.815q0-.356.247-.585A.89.89 0 0 1 7.874 4q.382 0 .628.23z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCollapseHeight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/collapse-height.be1be8e5.svg";